import React from 'react';
import ReactDOM from 'react-dom';
import i18next from 'i18next';
import store from '@/store';
import { setModalStatus } from '@/store/detail/action';
import styles from './index.module.less';

interface IModalProps {
  hide?: () => void;
}

export const Modal: React.FC<IModalProps> = () => {
  return (
    <div className={styles.modalWrapper}>
      <div className={styles.modal}>
        <div className={styles.title}>
          {i18next.t('alert_upgrade_title_seabank')}
        </div>
        <div className={styles.content}>
          {i18next.t('alert_upgrade_meessage_no_time')}
        </div>
        <div className={styles.operator}>
          <button
            className={styles.confirm}
            onClick={() => {
              WrapperModal(Modal).hide();
            }}
          >
            {i18next.t('bt_force_upgrade_download')}
          </button>
        </div>
      </div>
      <div className={styles.mask}></div>
    </div>
  );
};

const container = document.createElement('div');

const WrapperModal = (Component: React.FC<IModalProps>) => {
  const hide = function () {
    store.dispatch(setModalStatus({ isModalShow: false }));
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };
  const show = function (props?: IModalProps) {
    const { isModalShow } = store.getState().detail; // single instance
    if (isModalShow) return;
    store.dispatch(setModalStatus({ isModalShow: true }));
    document.body.appendChild(container);
    ReactDOM.render(<Modal />, container);
  };

  return {
    show,
    hide,
  };
};
export default WrapperModal(Modal);
